module.exports = __webpack_public_path__ + "static/media/hab3-0.048101fb.jpg";